export var ZIPCODE_NOT_FOUND_ERROR_CODE = 'PSTL_ERR_001';
export var INVALID_PAYMENT_ERROR_CODES = {
    PYMTCRD_ERR_108: 'PYMTCRD_ERR_108',
    PYMTCRD_ERR_109: 'PYMTCRD_ERR_108',
    PYMTCRD_ERR_140: 'PYMTCRD_ERR_140',
    PYMTCRD_ERR_159: 'PYMTCRD_ERR_159',
    PYMTCRD_ERR_127: 'PYMTCRD_ERR_127',
    PAYMENT_ERR_500: 'PAYMENT_ERR_500',
    PYMTCRD_ERR_197: 'PYMTCRD_ERR_197',
    PYMTCRD_ERR_202: 'PYMTCRD_ERR_202',
    PYMTCRD_ERR_203: 'PYMTCRD_ERR_203',
    PYMTCRD_ERR_204: 'PYMTCRD_ERR_204',
};
